export const projectInsuranceContent = {
    banner: {
        title: 'Project Insurance',
        titleBm: 'Insuran Kerja Projek',
        desc: '<span class="tw-font-bold">PROJECT INSURANCE</span> is a type of insurance specifically designed to cover the risks associated with construction projects or other large-scale undertakings. It provides financial protection against various unforeseen events that could disrupt the project, lead to financial losses, or result in liabilities. This insurance can cover a range of aspects, depending on the specific needs of the project.',
        descBm: '<span class="tw-font-bold">INSURANS PROJEK</span> ialah sejenis insurans yang direka khusus untuk menampung risiko yang berkaitan dengan projek pembinaan atau usaha berskala besar yang lain. Ia menyediakan perlindungan kewangan terhadap pelbagai kejadian yang tidak dijangka yang boleh mengganggu projek, membawa kepada kerugian kewangan atau mengakibatkan liabiliti. Insurans ini boleh meliputi pelbagai aspek, bergantung pada keperluan khusus projek.',
    },
    product: {
        desc: `<span class='tw-text-[#FF6700] tw-font-semibold'>BizCare</span> is All in One comprehensive insurance package - Broad enough to ensure you have sufficient cover, tailored to your business needs.`,
        descBm: `<span class='tw-text-[#FF6700] tw-font-semibold'>BizCare</span> ialah pakej insurans komprehensif yang meliputi banyak faedah untuk memastikan anda mempunyai perlindungan yang sesuai dan mengikut keperluan peniagaan anda.`,
    },
    who: {
        title: 'Who is this subscription for?',
        titleBm: 'Untuk siapa langganan ini?',
        desc: '<p>Project insurance can be beneficial for a variety of stakeholders involved in a construction project or any large-scale project.The primary parties that typically purchase or benefit from project insurance include:</p><ol class="!tw-text-left"><li>Project Owners</li><li>General Contractors</li><li>Subcontractors</li><li>Developers</li><li>Architects and Engineers</li><li>Financiers and Lenders</li><li>Investors</li></ol>',
        descBm: '<p>Insurans projek boleh memberi manfaat kepada pelbagai pihak berkepentingan yang terlibat dalam projek pembinaan atau mana-mana projek berskala besar.Pihak utama yang biasanya membeli atau mendapat manfaat daripada insurans projek termasuk:</p><ol class="!tw-text-left"><li>Pemilik Projek</li><li>Kontraktor Am</li><li>Subkontraktor</li><li>Pemaju</li><li>Arkitek dan Jurutera</li><li>Pembiaya dan Pemberi Pinjaman</li><li>Pelabur</li></ol>',
    },
    benefits: {
        title: 'What is the Insurance Coverage for Project?',
        titleBm: 'Apakah Perlindungan Insurans untuk Projek?',
        options: [
            {
                img: '/assets/images/insurance/Fire.png',
                title: 'Contractors All Risks Insurance',
                titleBm: 'Polisi Semua Risiko Kontraktor',
                desc: 'Contractors All Risks Insurance covers material damage and third party liabilities for a civil engineering project',
                descBm: 'Polisi Semua Risiko Kontraktor menyediakan melindungi kerosakan material dan liabiliti pihak ketiga.',
                addFeat: '',
                addFeatBm: '',
            },
            {
                img: '/assets/images/insurance/Business-Interruption.png',
                title: 'Erection All Risk Insurance',
                titleBm: 'Insurans Semua Risiko Pembinaan',
                desc: 'Erection All Risk Insurance cover material damage and third party liabilities for a installation, erection and commissioning of an equipment, structure or plant engineering project.',
                descBm: 'Insurans Semua Risiko Pembinaan melindungi kerosakan material dan liabiliti pihak ketiga untuk pemasangan, pembinaan dan pentauliahan peralatan, struktur atau projek kejuruteraan loji.',
                addFeat: '',
                addFeatBm: '',
            },
            {
                img: '/assets/images/insurance/Other-Coverage.png',
                title: 'Workman Compensation Insurance',
                titleBm: 'Polisi Pampasan Pekerja',
                desc: 'Workman Compensation Insurance protects the employer in respect of your statutory liability under the Workmen’s Compensation Act as well as at Common Law to your employees who are not covered by the Social Security Organisation (SOCSO) as provided for under the Employees Social Security Act 1969',
                descBm: 'Polisi Pampasan Pekerja ini melindungi anda sebagai seorang majikan berhubung dengan liabiliti undang-undang anda dibawah Akta Pampasan Pekerja dan juga Common Law terhadap pekerja-pekerja anda yang biasanya tidak terlindung oleh Pertubuhan Keselamatan Sosial Malaysia (SOCSO) sebagaimana diperuntukkan dibawah Akta Keselamatan Sosial Pekerja 1969.',
                addFeat: '',
                addFeatBm: '',
            },
            {
                img: '/assets/images/insurance/performance-bond-3.png',
                title: 'Performance Bond',
                titleBm: 'Insuran Bon',
                desc: 'Performance Bond is to ensure that contractors faithfully carry out the terms & conditions of a written contract. The amount of the bond will be recovered by the principal should the contractor fail to perform in accordance with the terms of the contract.',
                descBm: 'Insuran Bon pada asasnya ialah kontrak jaminan yang diberikan oleh sebuah syarikat insurans (penjamin) yang mana kontrak ini menjamin satu pihak (Prinsipal) bahawa Orang Yang Diinsuranskan akan menunaikan kewajipannya (untuk membayar sejumlah wang atau untuk melaksanakan kontrak).',
                addFeat: '',
                addFeatBm: '',
            },
        ],
    },
    form: {
        title: `Apply now for<br />Project Insurance.`,
        titleBm: 'Mohon sekarang.',
        desc: 'Only one more step to getting the support that you need - contact us now!',
        descBm: 'Hanya satu langkah lagi untuk mendapatkan sokongan yang anda perlukan - hubungi kami sekarang!',
        fields: {
            name: 'Name',
            nameBm: 'Nama',
            email: 'Email',
            emailBm: 'Alamat e-mel',
            phone: 'Phone No.',
            phoneBm: 'Nombor telefon',
            projectTitle: 'Project Title',
            projectTitleBm: 'Nama Projek',
            principalName: 'Name of Principal',
            principalNameBm: 'Nama Prinsipal',
            company: 'Company Name',
            companyBm: 'Nama Syarikat',
            insuranceType: 'Type of Insurance',
            insuranceTypeBm: 'Jenis Insurans',
            brn: 'Business Registration Number',
            brnBm: 'Nombor Pendaftaran Perniagaan',
            insuranceOptions: [
                {
                    en: 'Contractors All Risks Insurance / Erection All Risk Insurance',
                    bm: 'Insurans Semua Risiko Kontraktor / Insurans Semua Risiko Pembinaan',
                },
                {
                    en: 'Workman Compensation Insurance',
                    bm: 'Insurans Pampasan Pekerja',
                },
                {
                    en: 'Performance Bond',
                    bm: 'Bon Pelaksanaan',
                },
            ],

            natureOfBusinessOptions: [
                { en: 'Individual', bm: 'Individu' },
                { en: 'Sole Proprietorship', bm: 'Pemilikan Tunggal' },
                { en: 'Partnership', bm: 'Perkongsian' },
                {
                    en: 'Professional Service Providers',
                    bm: 'Penyedia Perkhidmatan Profesional',
                },
                { en: 'Sendirian Berhad', bm: 'Sendirian Berhad' },
                {
                    en: 'Limited Liability Partnership',
                    bm: 'Perkongsian Liabiliti Terhad',
                },
            ],
            terms: "By clicking 'Submit', you agree that you have given consent for us to contact you regarding your product application, and you further confirm that you have fully read, understood and agree to be bound by the terms of Liberty General Insurance Berhad's <a class='tw-text-blue-600 tw-underline tw-cursor-pointer' href='https://www.kurnia.com/privacy-policy-documents' target='_blank'  >Privacy Notice</a> and consent to the collection, process, usage, disclosure and retention of your personal data as described in the Privacy Notice.",
            termsBm:
                "Dengan menekan 'Hantar', anda bersetuju bahawa anda telah memberi kebenaran untuk kami menghubungi anda mengenai permohonan produk anda, dan anda turut mengesahkan bahawa anda telah membaca sepenuhnya, memahami dan bersetuju untuk terikat dengan terma <a class='tw-text-blue-600 tw-underline tw-cursor-pointer' href='https://www.kurnia.com/privacy-policy-documents' target='_blank'  >Notis Privasi</a> Liberty General Insurance Berhad dan bersetuju terhadap pengumpulan, pemprosesan, penggunaan, pendedahan dan penyimpanan data peribadi anda seperti yang diterangkan dalam Notis Privasi.",
        },
        errors: {
            name: 'Please enter Applicant Name that is valid up to 30 Characters (required)',
            nameBm: 'Sila masukkan Nama Pemohon yang sah sehingga 30 Aksara (wajib)',
            projectTitle:
                'Please enter Project Title that is valid up to 192 Characters (required)',
            projectTitleBm:
                'Sila masukkan Nama Projek yang sah sehingga 192 Aksara (wajib)',
            principalName:
                'Please enter Name of Prinicipal that is valid up to 192 Characters (required)',
            principalNameBm:
                'Sila masukkan Nama Prinsipal yang sah sehingga 192 Aksara (wajib)',
            email: 'Please enter valid Email Address (required)',
            emailBm: 'Sila masukkan Alamat e-mel  yang sah (wajib)',
            phone: 'Phone number should be a valid phone number',
            phoneBm: 'Sila masukkan nombor telefon yang sah.',
            company:
                'Please enter Company Name that is valid up to 50 Characters (required)',
            companyBm:
                'Sila masukkan Nama Syarikat yang sah sehingga 50 Aksara (wajib)',
            terms: 'Please accept Terms & Conditions',
            termsBm: 'Sila terima Terma & Syarat',
            insuranceType:
                'Please tick at least a Type of Insurance (required).',
            insuranceTypeBm: 'Sila pilih minimum 1 Jenis Insurans (wajib).',
            natureOfBusiness: '	Please make a selection (required)',
            natureOfBusinessBm: 'Sila pilih yang bersesuaian (wajib)',
            brn: 'Please enter a valid Business Registration No.',
            brnBm: 'Sila taipkan Nombor Pendaftaran Perniagaan yang sah',
        },
    },
};
